import * as React from 'react';
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import '../../Styles/Components/PublicForms/Dialog_alert.css';
import isTokenExpired from './isTokenExpired';
import {useNavigate } from "react-router-dom";
import iconAttention from '../../Images/iconAttention.png';


export default function Dialog_alert(props) {
  const [open, setOpen] = React.useState(props.show);
  const Navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const token = localStorage.getItem('token');
      if (isTokenExpired(token)) {
        localStorage.removeItem('token');
        Navigate("/login");
      } else {
        // setUser(JSON.parse(localStorage.getItem('user')));
      }
    } else {
        Navigate("/login");
    }
  }, []);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    props.closeOpenDialog(false);
  };

  return (
    <div className='dialog-container' >
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open alert dialog
      </Button> */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth = {true}
        maxWidth = {"100000px"}
      >
        <div className='alert_dialog_message'>

            <DialogTitle id="alert-dialog-title">
              <img src={iconAttention}/>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <div className='dialog-info'>

                    {props.message.map((mess)=>
                      <p>*{mess}</p>
                    )}

                </div>
              
              </DialogContentText>
            </DialogContent>
            <DialogActions className='actionButtons'>
              <Button onClick={handleClose} autoFocus>
                متوجه شدم
              </Button>
            </DialogActions>

        </div>
       
      </Dialog>
    </div>
  );
}
